import * as PIXI from 'pixi.js';
import { state } from '__common/store';

export function obstructionModel(coords: { x: number, y: number}[], obstructionId: number): any {
  const { settings: { canvasCenter } } = state();
  
  // Filter out invalid coordinates
  const validCoords = coords.filter(coord => coord && coord.x !== undefined && coord.y !== undefined && !isNaN(coord.x) && !isNaN(coord.y));
  
  if (validCoords.length < 3) {
    console.warn('Insufficient valid coordinates for obstruction polygon');
    return new PIXI.Graphics(); // Return empty graphics
  }

  const pixiPoints = validCoords.map(coord => new PIXI.Point(coord.x + canvasCenter.x, coord.y + canvasCenter.y));
  const obstruction = new PIXI.Graphics();
  obstruction.id = obstructionId;
  
  // PIXI v7: Configure obstruction for proper interaction
  obstruction.interactive = false; // Obstructions typically shouldn't be interactive
  obstruction.eventMode = 'none'; // No events needed for basic obstructions
  
  obstruction.beginFill(0x000000, 0.80);
  
  try {
    obstruction.drawPolygon(pixiPoints);
    obstruction.endFill();
  } catch (error) {
    console.error('Error drawing obstruction polygon:', error);
  }
  
  return obstruction;
}
